module.exports = __webpack_public_path__ + "static/media/small-check.03851710.svg";